import { defaultPagedCollection } from '@shared/models/pagination/default-paged-collection.config';
import { PagedCollection } from '@shared/models/pagination/paged-collection';
import { StoreSequence } from './models/store-sequence';

type PagedSequencesCollection = PagedCollection<{ [sequenceId: number]: StoreSequence }>;

export type SequencesState = {
  sequences: PagedCollection<{ [sequenceId: number]: StoreSequence }>;
  isLoaded: boolean;
};

export const initialSequencesState: SequencesState = {
  sequences: {
    ...(defaultPagedCollection as PagedSequencesCollection),
  },
  isLoaded: false,
};
